<template>
    <v-menu v-if="show_button && addList && menu" bottom left class="hidden-sm-and-down" v-show="$bp.xs">
        <!-- sets add list as a menu if prop 'menu' is true -->
        <v-btn icon slot="activator">
            <v-icon>{{ icon }}</v-icon>
        </v-btn>
        <v-list>
            <v-list-tile v-for="item in addList" :key="item.title" class="clickable" @click="$emit('invoke-method', item)">
                <v-list-tile-title>
                    {{ item.title }}
                </v-list-tile-title>
            </v-list-tile>
        </v-list>
    </v-menu>
    <div v-else-if="show_button && addList" class="hidden-sm-and-down inline-button-group" :class="{ show: showMore }">
        <!-- component will default to inline button group that slides in/out unless 'menu' prop is true-->
        <v-layout row ma-0 class="inline-button-group-inner">
            <v-flex pa-0 v-for="item in addList" :key="item.title" class="inline-button">
                <bc-tooltip v-bind="$attrs" class="hidden-sm-and-down">
                    <template slot="activator">
                        <v-btn icon @mouseup.left="$emit('invoke-method', item)">
                            <v-icon>{{ item.icon ? item.icon : "add" }}</v-icon>
                        </v-btn>
                    </template>
                    {{ item.title }}
                </bc-tooltip>
            </v-flex>
            <v-flex pa-0 class="add-button" @mouseup.left="showMore = !showMore">
                <bc-tooltip>
                    <template slot="activator">
                        <v-btn icon class="add-button-inner">
                            <v-icon>{{ icon }}</v-icon>
                        </v-btn>
                    </template>
                    {{ tooltip ? tooltip : $t("lang.addNew") }}
                </bc-tooltip>
            </v-flex>
        </v-layout>
    </div>
    <bc-tooltip v-else-if="show_button" v-bind="$attrs" :class="{ 'hidden-sm-and-down': !permanent }">
        <!-- single add button with customizeable tooltip -->
        <template slot="activator">
            <v-btn icon @mouseup.left="$emit('invoke-method', dialogInfo)">
                <v-icon class="material-icons-outlined">{{ icon }}</v-icon>
            </v-btn>
        </template>
        {{ tooltip ? tooltip : $t("lang.addNew") }}
    </bc-tooltip>
</template>

<script>
export default {
    props: {
        dialogModel: {
            type: String,
        },
        focus: {
            type: Boolean,
        },
        addList: {
            type: Array,
        },
        action: {
            type: String,
        },
        tooltip: {
            type: String,
        },
        menu: {
            type: Boolean,
        },
        permanent: {
            type: Boolean,
            default: false,
        },
        targetRef: {
            type: String,
        },
        icon: {
            type: String,
            default: "add",
        },
        perm: {
            type: String,
            default: null,
        },
        loginType: {
            type: String,
            default: null,
        },
    },
    computed: {
        dialogInfo() {
            if (this.dialogModel) {
                this.open_dialog.dialog_model = this.dialogModel;
            }
            if (this.focus) {
                this.open_dialog.focus = this.focus;
            }
            if (this.action) {
                this.open_dialog.action = this.action;
            } else {
                this.open_dialog.action = "control_dialog";
                this.open_dialog.status = true;
            }
            if (this.targetRef) {
                this.open_dialog.ref = this.targetRef;
            }
            return this.open_dialog;
        },
        show_button() {
            return (!this.perm || this.hasPerm(this.perm)) && (!this.loginType || this.hasLoginType([this.loginType]));
        },
    },
    data() {
        return {
            open_dialog: {},
            showMore: false,
        };
    },
};
</script>
